module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "width": "400"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        Confirma a exclusão do vínculo?\n      ")]), _vm._v(" "), _c('v-card-text', [(this.vinculoParaExclusao.tipoVinculo !== 'superior') ? _c('div', [_vm._v("\n          Este vinculo foi feito pelo coordenador da ação " + _vm._s(this.vinculoParaExclusao.idProjeto) + ".\n          Se ele for excluído apenas o coordenador desta ação poderá refazê-lo.\n        ")]) : _vm._e()]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteVinculo()
      }
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaVinculos,
      "search": _vm.search,
      "no-data-text": 'Esta ação não possui ações vinculadas.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.titulo",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "target": "_blank",
            "to": {
              name: 'ProjetoFormulario',
              params: {
                idProjeto: props.item.idProjeto
              }
            }
          }
        }, [_vm._v("\n        " + _vm._s(_vm.truncate(props.item.titulo, 100)) + "\n      ")])]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [(_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('v-btn', {
          attrs: {
            "color": "red darken-3",
            "text": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.botaoExcluirVinculo(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e()]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaVinculos.length) + " projetos\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": "ParceriasProjeto",
      "editar": "EditarProjetoSuperior",
      "nome_editar": "Vincular",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21815590","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projeto/projeto-vinculos-tabela.vue
// module id = 487
// module chunks = 0